(function () {
    'use strict';

    angular.module('NaviaqWebApp').directive('finalReportFooterAbyssDirective', finalReportFooterAbyssDirective);

    finalReportFooterAbyssDirective.$inject = [];
    function finalReportFooterAbyssDirective() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/report/clients/Abyss/finalReportComponents/final-report-footer-abyss.html',
            scope: {
                data: '=data'
            },
            link: function (scope, element, attrs) {
            },
        };
    }
})();
